import React, { useContext } from "react";
import {
  DatePicker,
  Select,
} from "antd";
import dayjs from "dayjs";
import CustomDebounceSearch from "./CustomDebounceSearch";
import { ChemBioPendingContext } from "../ChemBioPendingContext";

const PendingFilterSection = () => {
  const {
    showSearch,
    onSearch,
    selectedDate,
    handleDate,
    chemDropdown,
    chemFilterList,
    category,
    onChemFilterSelect,
    instrumentList,
    selectedInstrumentId,
    instrumentLoading,
    onInstrumentSelect,
    raList,
    technicianEmail,
    raLoading,
    onRaFilterSelect,
    categoryLoading,
    selectedInstrumentMethod,
    instrumentMethodList,
    methodLoading,
    onInstrumentMethodSelect,
  } = useContext(ChemBioPendingContext);

  return (
    <div className={`PendingTable__Wrap${chemDropdown ? "--Chem" : ""}`}>
      <div className="PendingTable__TopBar">
        { showSearch && (
        <CustomDebounceSearch onSearch={onSearch} />
        )}
        <DatePicker
          showNow
          allowClear={false}
          format="MM/DD/YYYY"
          defaultValue={(selectedDate === "" || selectedDate === "Invalid date") ? "" : dayjs(selectedDate)}
          className="PendingTable__Date"
          onChange={handleDate}
        />
        { chemDropdown && (
        <Select
          allowClear
          showSearch
          className="PendingTable__FilterSelect"
          popupClassName="PendingTable__FilterSelect__Menu"
          options={chemFilterList}
          defaultValue={chemFilterList[0]?.value}
          value={category}
          loading={categoryLoading}
          onSelect={onChemFilterSelect}
          onClear={() => onChemFilterSelect("")}
          filterOption={(inputValue, option) => option.value?.toLowerCase().startsWith(inputValue?.toLowerCase())}
          listHeight={400}
        />
        )}
        { chemDropdown && (
        <Select
          allowClear
          showSearch
          className="PendingTable__FilterSelect"
          popupClassName="PendingTable__FilterSelect__Menu"
          placeholder="Select Instrument"
          defaultValue={instrumentList[0]?.value}
          value={selectedInstrumentId}
          loading={instrumentLoading}
          options={instrumentList}
          onSelect={onInstrumentSelect}
          onClear={() => onInstrumentSelect("")}
          filterOption={(inputValue, option) => option.label?.toLowerCase().startsWith(inputValue?.toLowerCase())}
          listHeight={400}
        />
        )}
        { chemDropdown && (
        <Select
          allowClear
          showSearch
          className="PendingTable__FilterSelect"
          popupClassName="PendingTable__FilterSelect__Menu"
          placeholder="Select Instrument Method"
          defaultValue={instrumentMethodList[0]?.value}
          value={selectedInstrumentMethod}
          loading={methodLoading}
          options={instrumentMethodList}
          onSelect={onInstrumentMethodSelect}
          onClear={() => onInstrumentMethodSelect("")}
          filterOption={(inputValue, option) => option.label?.toLowerCase().startsWith(inputValue?.toLowerCase())}
          listHeight={400}
        />
        )}
        { chemDropdown && (
        <Select
          allowClear
          showSearch
          className="PendingTable__FilterSelect"
          popupClassName="PendingTable__FilterSelect__Menu"
          placeholder="Select Assigned To"
          defaultValue={raList[0]?.value}
          value={technicianEmail}
          loading={raLoading}
          options={raList}
          onSelect={onRaFilterSelect}
          onClear={() => onRaFilterSelect("")}
          filterOption={(inputValue, option) => option.label?.toLowerCase().startsWith(inputValue?.toLowerCase())}
          listHeight={400}
        />
        )}
      </div>
    </div>
  );
};

export default PendingFilterSection;
